import { render, staticRenderFns } from "./DatabaseTabPanel.vue?vue&type=template&id=96c26a18&"
import script from "./DatabaseTabPanel.vue?vue&type=script&lang=js&"
export * from "./DatabaseTabPanel.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseTabPanel.vue?vue&type=style&index=0&id=96c26a18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports